import { useEffect, useState } from "react";
import ServiceMenuAccordian from "./ServiceMenuAccordian";
import { CategoryAPI } from "../../../api";

const ServiceMenu = () => {
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		CategoryAPI.getAllCategories()
			.then((res) => setCategories(res.data))
			.catch((err) => console.error(err));
	}, []);

	return (
		<div className="accordion" id="services-accordion">
			{categories.map((category, index) => (
				<ServiceMenuAccordian
					key={index}
					parentId="services-accordion"
					id={category.id}
					title={category.title}
					slug={category.slug}
					categoryId={category.id}
					service_items={category.service_items}
				/>
			))}
		</div>
	);
};

export default ServiceMenu;
